import type * as GraphQLTypes from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdatePackagePaymentNoteMutationVariables = GraphQLTypes.Exact<{
  paymentId: GraphQLTypes.Scalars['String'];
  notes: GraphQLTypes.Scalars['String'];
}>;


export type UpdatePackagePaymentNoteMutationResult = (
  { __typename?: 'Mutation' }
  & Pick<GraphQLTypes.Mutation, 'updatePackagePaymentNote'>
);


export const UpdatePackagePaymentNoteDocument = /*#__PURE__*/ gql`
    mutation updatePackagePaymentNote($paymentId: String!, $notes: String!) {
  updatePackagePaymentNote(paymentId: $paymentId, notes: $notes)
}
    `;

/**
 * __useUpdatePackagePaymentNoteMutation__
 *
 * To run a mutation, you first call `useUpdatePackagePaymentNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePackagePaymentNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePackagePaymentNoteMutation, { data, loading, error }] = useUpdatePackagePaymentNoteMutation({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUpdatePackagePaymentNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePackagePaymentNoteMutationResult, UpdatePackagePaymentNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePackagePaymentNoteMutationResult, UpdatePackagePaymentNoteMutationVariables>(UpdatePackagePaymentNoteDocument, options);
      }
export type UpdatePackagePaymentNoteMutationHookResult = ReturnType<typeof useUpdatePackagePaymentNoteMutation>;